// Open the chat drawer on an EXPLICIT context with a prefilled draft.
//
// The drawer's default model pins context from the route when a chat is created, which
// works for entity pages. The alerts board is one route covering every contract, so it
// needs to say which campaign / IO / contract a new chat is about. A module-level
// listener keeps the seam one function wide: no provider, no context plumbing.

import { ChatContext } from './pageContext';

export interface ChatLaunch {
  context: ChatContext;
  draft: string;
}

type Listener = (launch: ChatLaunch) => void;

const listeners = new Set<Listener>();

export const subscribeChatLaunch = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

// No-op when the drawer is not mounted (feature gated off) — callers gate their
// affordances on agentChatEnabled rather than relying on this.
export const openAgentChat = (launch: ChatLaunch): void => {
  listeners.forEach((listener) => listener(launch));
};
